import { get_token } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import Loader from "@/components/Loader/LoaderView.vue";
import { get_retrieve_users_params } from "@/utils/organization_profile";
import { view_profile as view_profile_helper } from "@/views/Feed/feed_helper.js";
import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";

export default {
    components: {
        HomeNavBar,
        MenuSideBar,
        StickyNav,
        InactivityModal,
        Loader
      },
  data() {
    return ({
      users: [],
      userSearch: "",
      loading: true,
    });
  },
  computed: {
    home_feature_icons() {
      return HOME_FEATURE_ICONS;
    },
    search_result_label() {
      const total = this.users.length;
      const visible = this.filteredUsers.length;

      if (this.userSearch) {
        return `${visible} of ${total} members`;
      }

      return `${total} members`;
    },
    filteredUsers() {
      const searchTerm = this.userSearch.trim().toLowerCase();

      if (!searchTerm) return this.users;

      return this.users.filter(user =>
        [
          this.get_user_name(user),
        ].some(value => value.toLowerCase().includes(searchTerm))
      );
    },
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
          type: "GET",
          headers: {
            Authorization: `Token ${get_token()}`,
            "Content-Type": "application/json",
          },
          data: get_retrieve_users_params(),
          success: (response) => {
            if (response.status === "success" && response.data && response.data.users_list) {
              // Sort alphabetically by first name
              this.users = response.data.users_list.sort((a, b) =>
                this.get_user_name(a).toLowerCase().localeCompare(this.get_user_name(b).toLowerCase())
              );
            }
            this.loading = false;
          },
          error: (error) => {
            console.error("Error fetching users:", error);
            this.loading = false;
          },
        });
      },

      view_profile(user) {
        view_profile_helper(this.$router, user);
      },

      get_user_name(user) {
        return [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() || "Unnamed member";
      },

      get_user_initials(user) {
        const nameParts = this.get_user_name(user).split(" ").filter(Boolean);
        const initials = nameParts.slice(0, 2).map(name => name.charAt(0)).join("");

        return initials.toUpperCase() || "U";
      },

      clear_search() {
        this.userSearch = "";
      }
  },
};
